import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';
import { HolidaysComponent } from './holidays/holidays.component';
import { MomentModule } from 'ngx-moment';
import { HolidayEditComponent } from './holidays/holiday-edit/holiday-edit.component';
import { HolidayGroupsComponent } from './holiday-groups/holiday-groups.component';
import { HolidayGroupEditComponent } from './holiday-groups/holiday-group-edit/holiday-group-edit.component';
import { BillingComponent } from './billing.component';
import { SchedulesComponent } from './schedules/schedules.component';
import { ScheduleEditComponent } from './schedules/schedule-edit/schedule-edit.component';
import { ExportListComponent } from './export-list/export-list.component';
import { ArticlesComponent } from './articles/articles.component';
import { ArticleCreateComponent } from './articles/article-create/article-create.component';
import { WaitingTimesComponent } from './waiting-times/waiting-times.component';
import { WaitingTimeEditComponent } from './waiting-times/waiting-time-edit/waiting-time-edit.component';
import { ArticleIndexingDialogComponent } from './articles/article-indexing-dialog/article-indexing-dialog.component';

@NgModule({
  declarations: [
    BillingComponent,
    HolidaysComponent,
    HolidayEditComponent,
    HolidayGroupsComponent,
    HolidayGroupEditComponent,
    SchedulesComponent,
    ScheduleEditComponent,
    ExportListComponent,
    ArticlesComponent,
    ArticleCreateComponent,
    WaitingTimesComponent,
    WaitingTimeEditComponent,
    ArticleIndexingDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule,
    MomentModule,
  ],
})
export class BillingModule {}
